<form [formGroup]="formGroup">
  <app-basic-load-configuration-options
    [formGroup]="formGroup"
    [configuration]="configuration"
    [configurationMode]="configurationMode">
  </app-basic-load-configuration-options>
  <div *ngIf="configurationMode !== 'STANDARD' && configuration?.fileCurrency?.visible !== false">
    <mat-form-field class="half-width">
      <mat-label>Devise du fichier</mat-label>
      <mat-select formControlName="fileCurrency">
        <mat-option 
            *ngFor="let currency of fileCurrencyOptions"
            [value]="currency">
            {{currency}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-icon
      [matTooltip]="fileCurrencyTooltipText"
      matTooltipClass="multiline-tooltip">
      help
    </mat-icon>
  </div>
  <mat-slide-toggle *ngIf="configuration?.entryLabelCodeMapping?.visible !== false" formControlName="entryLabelCodeMapping">
  <span>Renseigner les codes libellés</span>
  </mat-slide-toggle>
</form>